import React, { useRef } from "react";
import { Box, Button, Container, useTheme } from "@mui/material";
import { tokens } from "../../../theme";
import Header from "./components/Header";
import EventAndMemorial from "./components/EventAndMemorial";
import PackagesList from "./components/PackagesList";
import ServiceDescription from "./components/ServiceDescription";
import TermsAndConditions from "./components/TermsAndCondition";
import Footer from "./components/Footer";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

const ServiceQuotation: React.FC = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const quotationRef = useRef<HTMLDivElement>(null);

  const handleDownloadPDF = async () => {
    if (!quotationRef.current) return;

    try {
      const canvas = await html2canvas(quotationRef.current, {
        scale: 1.2,
        useCORS: true,
        backgroundColor: colors.primary[900],
      });

      const imgData = canvas.toDataURL("image/jpeg", 0.75);

      const pdf = new jsPDF("p", "mm", "a4");

      const pdfWidth = 210;
      const imgHeight = (canvas.height * pdfWidth) / canvas.width;

      pdf.addImage(imgData, "JPEG", 0, 0, pdfWidth, imgHeight);
      pdf.save("Service-Quotation.pdf");
    } catch (error) {
      console.error("Error generating PDF:", error);
    }
  };

  return (
    <Box sx={{ minHeight: "100vh", py: 2 }}>
      <Box
        textAlign="center"
        mb={2}
        sx={{ display: "flex", justifyContent: "flex-end" }}
      >
        <Button variant="contained" onClick={handleDownloadPDF}>
          Download PDF
        </Button>
      </Box>

      {/* PDF CONTENT */}
      <div
        ref={quotationRef}
        style={{
          padding: 0,
          margin: 4,
          fontSize: "20px",
          lineHeight: 1.4,
          fontFamily: "Inter, Arial, sans-serif",
          backgroundColor: colors.primary[900],
        }}
      >
        <Container
          maxWidth={false}
          disableGutters
          sx={{
            padding: 0,
            margin: 0,
            bgcolor: colors.primary[900],
          }}
        >
          <Header />
          <EventAndMemorial />
          <ServiceDescription />
          <PackagesList />
          <TermsAndConditions />
          <Footer />
        </Container>
      </div>
    </Box>
  );
};

export default ServiceQuotation;
